$(() => {
    // Load tips on page load if block exists
	if ($('.block.tips.show-all').length) {
		get_posts();
	}

	// Sort By
	$('.block.tips.show-all select[name="sort-by"]').on('change', function() {
		get_posts();
	});

    /**
     * Get tips
     */
    function get_posts() {
        var parent = $('.block.tips.show-all');
        if (!parent.length) return false;
        var container = parent.find('.items');
        if (!container.length) return false;

        // Remove existing items in the container
        container.empty();

        // Show loading
        parent.find('.loading').addClass('active');

        // Define tax query
        var parentCategory = parent.attr('data-parent-category');
        var taxQuery = null;
        if (parentCategory) {
            taxQuery = [{
                taxonomy: 'tip_category',
                field: 'slug',
                terms: parentCategory,
                operator: 'IN',
            }];
        }

        // Get order settings
        var order = parent.find('select[name="sort-by"]').val();

        // Grab the posts via Ajax
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            dataType: 'json',
            data: { 
                action: 'get_tips',
                tax_query: taxQuery,
                order: order,
            },
            success: function(response) {
                // Error message
                if (!response.success) {
                    console.log(response.message);
                    return false;
                }

                var data = response.data;

                // Show no data message
                if (!data.length) {
                    container.append('<div class="well">No posts found.</div>');
                }

                // Loop through the data
                else {
                    for (var i = 0; i < data.length; i++) {
                        var item = data[i];

                        // Create a div for each item
                        var $item = $(item.html);
                        container.append($item);
                    }
                }

                // Hide loading
                parent.find('.loading').removeClass('active');

                // Update AJAX pagination
                window.pagination.setTotal(data.length);
                window.pagination.update();
            }
        });
    }
})